import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_xpwFaJaSB',
      userPoolClientId: '1cbq45gvjhdb07lpv4mllkkm00',
      region: 'us-east-2',
    }
  }
});
